import * as constants from './constants';

const INITIAL_STATE = {
  userData: {
    type: '',
    name: '',
    uid: '',
    activeOfflinePurchaseOrders: 0,
    activeOfflineServiceRequests: 0,
    activeOnlinePurchaseOrders: 0,
    activeOnlineServiceRequests: 0,
    activePurchaseOrders: 0,
    activeServiceRequestData: [],
    activeServiceRequests: 0,
    astrapaySignature: '',
    address: '',
    buyerList: [],
    currency: {},
    currentTier: '',
    customerEmail: '',
    customerId: '',
    customerNIK: '',
    customerNo: '',
    customerNoTDMS: '',
    customerQRImage: '',
    dateOfBirth: '',
    defaultAddress: {},
    displayUid: '',
    email: '',
    firstName: '',
    fullName: '',
    gender: '',
    interest1: '',
    interest1List: {
      entry: [],
    },
    interest2: '',
    interest2List: {
      entry: [],
    },
    isActive: false,
    isEmailVerified: false,
    isPhoneVerified: false,
    isWAVerified: false,
    language: {},
    lastName: '',
    nickName: '',
    occupation: '',
    occupationList: {
      entry: [],
    },
    otherInterest: '',
    phoneNumber: '',
    referral: '',
    vehicleDetails: [],
    verifiedDatePhoneNo: '',
    astrapayToken: null,
    isProfileCompleteOnline: false,
    isUpdatePhone: false,
    earnPointNotif: '',
    subInterest1: '',
    subInterest2: '',
    subsFollowerCount: '',
    monthlyIncome: '',
    jobTitle: '',
    jobLevel: '',
    companyName: '',
    industry: '',
    subIndustry: '',
    favoriteFood: '',
    favoriteDrink: '',
    favoriteColor: '',
    occupationOther: '',
    otherIndustry: '',
    otherSubIndustry: '',
    otherJobLevel: '',
    otherSubInterest1: '',
    otherSubInterest2: '',
    otherColor: '',
    city: { isocode: '', name: '' },
    isLoyaltyTierConfig: false,
    isQRTierConfig: false,
    isQRConfig: false,
    temporaryEmail: '',
    isProfileCompleteLoyalty: null,
    haveEarnPoint: false,
  },
  isAuth: false,
  isLoggedIn: false,
  showPhoneVerificationModal: false,
  showEmailVerificationModal: false,
  isErrorLoginDAC: false,
  isLoadingLoginDAC: false,
  isLoading: false,
};

const exportedObject = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.SET_USER_DATA:
      return Object.assign({}, state, {
        userData: action.payload,
      });
    case constants.SET_AUTH_USER:
      return Object.assign({}, state, {
        isAuth: action.payload,
      });
    case constants.IS_LOGGED_IN:
      return { ...state, isLoggedIn: action.payload };
    case constants.SET_SHOW_PHONE_VERIFICATION_MODAL:
      return { ...state, showPhoneVerificationModal: action.payload };
    case constants.SET_SHOW_EMAIL_VERIFICATION_MODAL:
      return { ...state, showEmailVerificationModal: action.payload };
    case constants.SET_ERROR_LOGIN_DAC:
      return { ...state, isErrorLoginDAC: action.payload };
    case constants.SET_LOADING_LOGIN_DAC:
      return { ...state, isLoadingLoginDAC: action.payload };
    case constants.SET_LOADING:
      return { ...state, isLoading: action.payload };
    default:
      return state;
  }
};

export default exportedObject;
